export default "__VITE_PUBLIC_ASSET__38d61811__"